<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="filtered_options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på status</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'StoreFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        filter: {
            type: Function,
            default(options) {
                return options;
            },
        },
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];
            await BackendRepository.getStatuses().then((res) => {
                options = res;
            });

            return options;
        },
    },
    computed: {
        filtered_options() {
            return this.options.filter(this.filter);
        },
    },
};
</script>
